import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import RollingText from "../RollingText/RollingText";


import Aboutim1 from '../../images/our-service01.png';
import Aboutim2 from '../../images/our-service02.png';
import Aboutim3 from '../../images/our-service03.png';
import Aboutim4 from '../../images/our-service04.png';
gsap.registerPlugin(ScrollTrigger);
const About2 = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }


    useEffect(() => {

        const animatedElements = document.querySelectorAll(".new_img-animet");
        animatedElements.forEach((element) => {
            const image = element.querySelector("img");
            if (!image) return;

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: "top 50%",
                    toggleActions: "play none none reverse",
                },
            });

            tl.set(element, { autoAlpha: 1 });
            tl.from(element, { xPercent: -100, duration: 1.5, ease: "power2.out" });
            tl.from(image, { xPercent: 100, scale: 1.3, delay: -1.5, ease: "power2.out" });
        });

        return () => ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    }, []);

    return (

        <section className="about-section-s2">
            <div className="top-img">
                <div className="container">
                    <div className="title" style={{marginBottom:"50px"}}>
                        <h2 className="scroll-text-animation" data-animation="fade_from_bottom">Mrmetallo Service</h2>
                        <div className="title-bottom">
                            <h3 className="scroll-text-animation" data-animation="fade_from_bottom" style={{fontSize: window.innerWidth >= 768 ? "48px" : "30px"}}>OUR SERVICE</h3>
                            <Link onClick={ClickHandler} to="/business-area" className="scroll-text-animation" data-animation="fade_from_bottom"> <span className="rolling-text" style={{marginRight:"10px"}}>서비스 상세보기</span>
                                <i className="ti-arrow-top-right"></i>
                            </Link>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-5 col-12 scroll-text-animation" data-animation="fade_from_left" style={{ position: 'relative' }}>
                            <img src={Aboutim1} alt="" />
                            <div style={{
                                position: 'absolute',
                                bottom: window.innerWidth >= 768 ? '20px' : '40px',
                                right: '20px',
                                color: '#fff',
                                fontSize: window.innerWidth >= 768 ? '24px' : '18px',
                                fontWeight: '700'
                            }}>
                                폐수 재이용사업
                            </div>
                        </div>
                        <div className="col-lg-7 col-12 scroll-text-animation" data-animation="fade_from_right">
                            <img src={Aboutim2} alt="" />
                            <div style={{
                                position: 'absolute',
                                bottom: window.innerWidth >= 768 ? '20px' : '40px',
                                right: '20px',
                                color: '#fff',
                                fontSize: window.innerWidth >= 768 ? '24px' : '18px',
                                fontWeight: '700'
                            }}>
                                금속원료 재생사업
                            </div>
                        </div>
                    </div>
                    <div className="row" style={ window.innerWidth >= 768 ? {marginTop:"20px"} : {}}>
                        <div className="col-lg-7 col-12 scroll-text-animation" data-animation="fade_from_right">
                            <img src={Aboutim3} alt="" />
                            <div style={{
                                position: 'absolute',
                                bottom: window.innerWidth >= 768 ? '20px' : '40px',
                                right: '20px',
                                color: '#fff',
                                fontSize: window.innerWidth >= 768 ? '24px' : '18px',
                                fontWeight: '700'
                            }}>
                                지정폐기물 종합 재활용 사업
                            </div>
                        </div>
                        <div className="col-lg-5 col-12 scroll-text-animation" data-animation="fade_from_left">
                            <img src={Aboutim4} alt="" />
                            <div style={{
                                position: 'absolute',
                                bottom: window.innerWidth >= 768 ? '20px' : '40px',
                                right: '20px',
                                color: '#fff',
                                fontSize: window.innerWidth >= 768 ? '24px' : '18px',
                                fontWeight: '700'
                            }}>
                                폐수처리업
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default About2;